/* eslint-disable no-self-compare */
import { Table, TableBody } from '@material-ui/core';
import React from 'react';
import OITableCells from './OITableCells';
import OITableHeadingRow from './OITableHeadingRow';

const OIModelTable = ({ styles2, styles, order, orderBy, state, setState }) => {
  return (
    <div style={{ ...styles2.OIModalTableContainer, width: '90%' }}>
      <Table>
        <OITableHeadingRow
          state={state}
          setState={(data) => setState(data)}
          styles={styles}
          styles2={styles2}
          order={order}
          orderBy={orderBy}
        />
        <TableBody>
          {state.tableData &&
            state.tableData
              .sort((a, b) => {
                if (
                  !orderBy ||
                  (!(
                    typeof a[orderBy] === 'number' ||
                    typeof a[orderBy] === 'string'
                  ) &&
                    typeof a[orderBy] === typeof a[orderBy])
                ) {
                  return new Date(b.date) - new Date(a.date);
                }

                if (orderBy === 'bidside' || orderBy === 'askside') {
                  return order === 'desc'
                    ? a[orderBy] / a['volume'] - b[orderBy] / b['volume']
                    : b[orderBy] / b['volume'] - a[orderBy] / a['volume'];
                } else {
                  if (typeof a[orderBy] === 'number')
                    return order === 'desc'
                      ? a[orderBy] - b[orderBy]
                      : b[orderBy] - a[orderBy];
                  else {
                    return order === 'desc'
                      ? a[orderBy].localeCompare(b[orderBy])
                      : b[orderBy].localeCompare(a[orderBy]);
                  }
                }
              })
              .map((row) => <OITableCells row={row} styles2={styles2} />)}
        </TableBody>
      </Table>
    </div>
  );
};
export default OIModelTable;



// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/components/OIModalTable.jsx